import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ allowedRoles, children }) => {
    const {
        activeRole,
        userRoles,
        loading,
        isAuthenticated,
        switchRole,
        user,
    } = useAuth();

    const [authorized, setAuthorized] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);

    useEffect(() => {
        const checkAuthorization = () => {
            // console.log("Current active role:", activeRole);
            // console.log("Allowed roles for this route:", allowedRoles);
            // console.log("User's roles:", userRoles);

            // If not authenticated, exit early
            if (!isAuthenticated) {
                setAuthorized(false);
                setCheckingAuth(false);
                return;
            }

            // Initial check based on the active role
            let isAuthorized = activeRole && allowedRoles.includes(activeRole);

            // If not authorized by active role and user has roles, check all their roles
            if (!isAuthorized && userRoles && userRoles.length > 0) {
                // Map the backend role names to navigation role names
                const mappedRoles = userRoles.map((role) => {
                    switch (role) {
                        case "guide":
                            return "guide";
                        case "thrustarea coordinator":
                            return "thrustarea";
                        case "examiner":
                            return "examiner";
                        case "project coordinator":
                            return "pc";
                        default:
                            return role;
                    }
                });

                // Check if any of the user's roles are in the allowed roles list
                isAuthorized = mappedRoles.some((role) =>
                    allowedRoles.includes(role)
                );

                // If authorized but active role is different, update the active role
                if (isAuthorized && !allowedRoles.includes(activeRole)) {
                    // Find the first allowed role to activate
                    const newActiveRole = mappedRoles.find((role) =>
                        allowedRoles.includes(role)
                    );

                    if (newActiveRole) {
                        // console.log("Switching active role to:", newActiveRole);
                        try {
                            switchRole(newActiveRole)
                                .then((role) => {
                                    // console.log(
                                    //    "Role switched successfully to:",
                                    //    role
                                    //);
                                })
                                .catch((error) => {
                                    console.error(
                                        "Error switching role:",
                                        error
                                    );
                                    // Don't log out or change authorization - just keep going with current role
                                });
                        } catch (error) {
                            console.error("Error in role switch:", error);
                        }
                    }
                }

                // console.log("Route access based on all roles:", isAuthorized);
            }

            setAuthorized(isAuthorized);
            setCheckingAuth(false);
        };

        if (!loading) {
            checkAuthorization();
        }
    }, [
        activeRole,
        userRoles,
        allowedRoles,
        loading,
        switchRole,
        isAuthenticated,
    ]);

    if (loading || checkingAuth) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (!authorized) {
        // console.log("Access denied for route");
        alert(
            "You don't have permission to access this page. Redirecting to the Login page."
        );
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
